import {
  StrapiMenuHeaderDTO,
  MenuHeaderDTO,
} from "@lib/strapi/dtos/components/menu/menuHeader.dto";

export class StrapiMenuStructDTO {
  constructor() {}

  name: string;
  slug: string;
  menuItems: StrapiMenuHeaderDTO[];
}

export class MenuStructDTO {
  constructor() {}

  extraData: any = {};
  name: string;
  slug: string;
  menuItems: MenuHeaderDTO[];
}
